import booksEn from '../games/anagram-guess/books.json';
import pairsEn from '../games/bible-pairs/pairs.json';
import hebrewAlpha from '../games/hebrew-alphabet/alphabet.json';
import greekAlpha from '../games/greek-alphabet/alphabet.json';
import numbersEn from '../games/bible-numbers/questions.json';
import versesEn from '../games/missing-word/verses.json';
import quotesEn from '../games/who-said-it/quotes.json';
import eventsEn from '../games/bible-timeline/events.json';
import locationsEn from '../games/verse-locator/locations.json';
import placesEn from '../games/bible-geography/places.json';
import parablesEn from '../games/parables-quiz/parables.json';
import matchesEn from '../games/kings-prophets/matches.json';
import miraclesEn from '../games/miracles-quiz/miracles.json';
import proverbsEn from '../games/proverbs-match/proverbs.json';
import occupationsEn from '../games/bible-occupations/occupations.json';
import promisesEn from '../games/promises-of-god/promises.json';
import apostlesEn from '../games/apostles-quiz/apostles.json';
import animalsEn from '../games/bible-animals/animals.json';
import plantsEn from '../games/bible-plants/plants.json';
import watersEn from '../games/bible-waters/waters.json';
import citiesEn from '../games/bible-cities/cities.json';
import foodsEn from '../games/bible-foods/foods.json';
import feastsEn from '../games/bible-feasts/feasts.json';
import commandmentsEn from '../games/bible-commandments/commandments.json';
import mountainsEn from '../games/bible-mountains/mountains.json';
import dreamsEn from '../games/bible-dreams/dreams.json';
import battlesEn from '../games/bible-battles/battles.json';
import covenantsEn from '../games/bible-covenants/covenants.json';
import songsEn from '../games/bible-songs/songs.json';
import clothingEn from '../games/bible-clothing/clothing.json';
import nationsEn from '../games/bible-nations/nations.json';
import tribesEn from '../games/bible-tribes-match/tribes.json';
import versesBuilderEn from '../games/verse-builder/verses.json';
import statementsEn from '../games/true-or-false/statements.json';
import namesEn from '../games/bible-hangman/names.json';
import memoryEn from '../games/bible-memory/memory.json';
import prayersEn from '../games/bible-prayers/prayers.json';
import familiesEn from '../games/bible-families/families.json';
import oddOneOutEn from '../games/odd-one-out/oddoneout.json';
import chainNamesEn from '../games/bible-chain/names.json';
import scenesEn from '../games/bible-scenes/scenes.json';

export const questionCounts = {
  'anagram-guess': booksEn.length,
  'bible-pairs': pairsEn.length,
  'hebrew-alphabet': hebrewAlpha.length,
  'greek-alphabet': greekAlpha.length,
  'bible-numbers': numbersEn.length,
  'books-sort': booksEn.length,
  'old-or-new': booksEn.length,
  'missing-word': versesEn.length,
  'who-said-it': quotesEn.length,
  'bible-timeline': eventsEn.length,
  'verse-locator': locationsEn.length,
  'bible-geography': placesEn.length,
  'parables-quiz': parablesEn.length,
  'kings-prophets': matchesEn.length,
  'miracles-quiz': miraclesEn.length,
  'proverbs-match': proverbsEn.length,
  'bible-occupations': occupationsEn.length,
  'promises-of-god': promisesEn.length,
  'apostles-quiz': apostlesEn.length,
  'bible-animals': animalsEn.length,
  'bible-plants': plantsEn.length,
  'bible-waters': watersEn.length,
  'bible-cities': citiesEn.length,
  'bible-foods': foodsEn.length,
  'bible-feasts': feastsEn.length,
  'bible-commandments': commandmentsEn.length,
  'bible-mountains': mountainsEn.length,
  'bible-dreams': dreamsEn.length,
  'bible-battles': battlesEn.length,
  'bible-covenants': covenantsEn.length,
  'bible-songs': songsEn.length,
  'bible-clothing': clothingEn.length,
  'bible-nations': nationsEn.length,
  'bible-tribes-match': tribesEn.length,
  'verse-builder': versesBuilderEn.length,
  'true-or-false': statementsEn.length,
  'bible-hangman': namesEn.length,
  'bible-memory': memoryEn.length,
  'bible-prayers': prayersEn.length,
  'bible-families': familiesEn.length,
  'odd-one-out': oddOneOutEn.length,
  'bible-chain': chainNamesEn.validNames.length,
  'bible-scenes': scenesEn.length,
  'bible-puzzle': scenesEn.length,
};

export const totalQuestions = Object.values(questionCounts).reduce((a, b) => a + b, 0);
